import Button from '@material-ui/core/Button';
import React from 'react';
import { connect } from 'unistore/full/react';
import actions from './actions';
import Typography from '@material-ui/core/Typography';
import './LoginScreen.css';

export default connect(
  null,
  actions
)(({ login }) => (
  <div className="LoginScreen">
    <Typography gutterBottom variant="h5" component="h2">
      Spotify Prototype
    </Typography>
    <Typography component="p">Log in below to get started</Typography>
    <Button
      variant="contained"
      color="primary"
      className="LoginScreen__LoginButton"
      onClick={login}
    >
      Log in
    </Button>
  </div>
));
